<template>
  <div>
    <!-- Show SignPdf component initially -->
    <div v-if="currentView === 'sign'">
      <sign-pdf 
        :isEmbedded="false" 
        :translations="translations"
        @navigate-to-editor="handleNavigateToEditor"
      />
    </div>

    <!-- Show PdfEditor component after navigation -->
    <div v-else-if="currentView === 'editor'">
      <pdf-editor 
        :initialSignature="signatureData"
        :translations="translations"
        @back-to-sign="handleBackToSign"
        @pdf-uploaded="handlePdfUploaded"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import SignPdf from './SignPdf.vue'
import PdfEditor from './PdfEditor.vue'

const props = defineProps({
  translations: {
    type: Object,
    default: () => ({})
  }
})

const currentView = ref('sign') // 'sign' or 'editor'
const signatureData = ref(null)
const hasPdfUploaded = ref(false)

// Watch for changes and hide/show hero text and other sections in DOM
watch([currentView, hasPdfUploaded], ([view, uploaded]) => {
  const elementsToToggle = [
    'hero-text',
    'what-is-section', 
    'how-to-section', 
    'features-section', 
    'ways-section',
    'legally-valid-section',
    'why-choose-section',
    'use-cases-section',
    'security-section',
    'faq-section',
    'footer-section'
  ]

  const shouldHide = view === 'editor' && uploaded

  elementsToToggle.forEach(id => {
    const el = document.getElementById(id)
    if (el) {
      el.style.display = shouldHide ? 'none' : ''
    }
  })

  document.querySelectorAll('section').forEach(el => {
    el.style.display = shouldHide ? 'none' : ''
  })
})

function handleNavigateToEditor(signature) {
  // Save signature data
  signatureData.value = signature
  // Switch to editor view
  currentView.value = 'editor'
}

function handleBackToSign() {
  // Go back to sign view
  currentView.value = 'sign'
  hasPdfUploaded.value = false
}

function handlePdfUploaded() {
  // PDF has been uploaded
  hasPdfUploaded.value = true
}
</script>
